function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  id: "bg",
  width: 36,
  height: 36,
  rx: 6,
  fill: "rgba(255,255,255,0.07)",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 1
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_33267",
  "data-name": "Path 33267",
  d: "M568.548,452.37l-4.027,4.026h11.913v1.188H564.521l4.027,4.026-.854.854-5.047-5.047-.408-.427.408-.427,5.047-5.046Z",
  transform: "translate(-562.239 -451.517)",
  fill: "#fff"
});

function SvgBackArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Menu_icon",
    "data-name": "Menu icon",
    transform: "translate(0.5 0.5)"
  }, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "Menu",
    transform: "translate(11 12)",
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_55298",
    "data-name": "Group 55298",
    style: {
      isolation: "isolate"
    }
  }, _ref3))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.2c900a3a.svg";
export { ForwardRef as ReactComponent };